(function () {
  'use strict';

  var MAPS_LOAD_TIMEOUT_MS = 10000;

  var STATE_NAMES = {
    AL: 'Alabama', AK: 'Alaska', AZ: 'Arizona', AR: 'Arkansas', CA: 'California',
    CO: 'Colorado', CT: 'Connecticut', DE: 'Delaware', FL: 'Florida', GA: 'Georgia',
    HI: 'Hawaii', ID: 'Idaho', IL: 'Illinois', IN: 'Indiana', IA: 'Iowa',
    KS: 'Kansas', KY: 'Kentucky', LA: 'Louisiana', ME: 'Maine', MD: 'Maryland',
    MA: 'Massachusetts', MI: 'Michigan', MN: 'Minnesota', MS: 'Mississippi', MO: 'Missouri',
    MT: 'Montana', NE: 'Nebraska', NV: 'Nevada', NH: 'New Hampshire', NJ: 'New Jersey',
    NM: 'New Mexico', NY: 'New York', NC: 'North Carolina', ND: 'North Dakota', OH: 'Ohio',
    OK: 'Oklahoma', OR: 'Oregon', PA: 'Pennsylvania', RI: 'Rhode Island', SC: 'South Carolina',
    SD: 'South Dakota', TN: 'Tennessee', TX: 'Texas', UT: 'Utah', VT: 'Vermont',
    VA: 'Virginia', WA: 'Washington', WV: 'West Virginia', WI: 'Wisconsin', WY: 'Wyoming',
    DC: 'District of Columbia'
  };

  var MAP_STYLES = [
    { elementType: 'geometry', stylers: [{ color: '#f5f1eb' }] },
    { elementType: 'labels.text.fill', stylers: [{ color: '#523735' }] },
    { elementType: 'labels.text.stroke', stylers: [{ color: '#f5f1eb' }] },
    { featureType: 'administrative', elementType: 'geometry.stroke', stylers: [{ color: '#c9b2a6' }] },
    { featureType: 'administrative.land_parcel', elementType: 'geometry.stroke', stylers: [{ color: '#dcd2be' }] },
    { featureType: 'administrative.land_parcel', elementType: 'labels.text.fill', stylers: [{ color: '#ae9e90' }] },
    { featureType: 'landscape.natural', elementType: 'geometry', stylers: [{ color: '#e8e0d8' }] },
    { featureType: 'poi', elementType: 'geometry', stylers: [{ color: '#dfd2ae' }] },
    { featureType: 'poi', elementType: 'labels.text.fill', stylers: [{ color: '#93817c' }] },
    { featureType: 'poi.park', elementType: 'geometry.fill', stylers: [{ color: '#cde6c7' }] },
    { featureType: 'poi.park', elementType: 'labels.text.fill', stylers: [{ color: '#447530' }] },
    { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#f5f1eb' }] },
    { featureType: 'road', elementType: 'geometry.stroke', stylers: [{ color: '#e0d6cc' }] },
    { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#e8d5b7' }] },
    { featureType: 'road.highway', elementType: 'geometry.stroke', stylers: [{ color: '#d4c4a8' }] },
    { featureType: 'road.highway.controlled_access', elementType: 'geometry', stylers: [{ color: '#e0c8a0' }] },
    { featureType: 'road.highway.controlled_access', elementType: 'geometry.stroke', stylers: [{ color: '#d4b88c' }] },
    { featureType: 'road.local', elementType: 'labels.text.fill', stylers: [{ color: '#806b63' }] },
    { featureType: 'transit.line', elementType: 'geometry', stylers: [{ color: '#dfd2ae' }] },
    { featureType: 'transit.line', elementType: 'labels.text.fill', stylers: [{ color: '#8f7d77' }] },
    { featureType: 'transit.line', elementType: 'labels.text.stroke', stylers: [{ color: '#ebe3cd' }] },
    { featureType: 'transit.station', elementType: 'geometry', stylers: [{ color: '#dfd2ae' }] },
    { featureType: 'water', elementType: 'geometry.fill', stylers: [{ color: '#c4d7e0' }] },
    { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#92998d' }] }
  ];

  function initSalonLocator(sectionId, apiKey) {
    var dataEl = document.getElementById('salon-locator-data-' + sectionId);
    var mapEl = document.getElementById('salon-locator-map-' + sectionId);
    var skeletonEl = document.getElementById('salon-locator-skeleton-' + sectionId);
    var mapWrapper = document.getElementById('salon-locator-map-wrapper-' + sectionId);
    var cardsContainer = document.getElementById('salon-locator-cards-' + sectionId);
    var searchForm = document.getElementById('salon-locator-search-form-' + sectionId);
    var searchInput = document.getElementById('salon-locator-search-input-' + sectionId);
    var searchError = document.getElementById('salon-locator-search-error-' + sectionId);
    var clearBtn = document.getElementById('salon-locator-clear-' + sectionId);
    var geoBtn = document.getElementById('salon-locator-geolocation-' + sectionId);
    var resultsContainer = document.getElementById('salon-locator-results-' + sectionId);
    var resetBtn = document.getElementById('salon-locator-reset-' + sectionId);

    if (!dataEl || !mapEl || !apiKey) {
      handleMapFailure(mapWrapper, skeletonEl);
      return;
    }

    var salons;
    try {
      salons = JSON.parse(dataEl.textContent);
    } catch (e) {
      handleMapFailure(mapWrapper, skeletonEl);
      return;
    }

    if (salons.length === 0) {
      handleMapFailure(mapWrapper, skeletonEl);
      return;
    }

    expandStateNames();
    initStateGroups(cardsContainer);

    loadGoogleMapsApi(apiKey, function (success) {
      if (!success) {
        handleMapFailure(mapWrapper, skeletonEl);
        return;
      }

      var mapState = renderMap(sectionId, mapEl, skeletonEl, mapWrapper, cardsContainer, salons, resetBtn);

      initSearch(searchForm, searchInput, searchError, clearBtn, geoBtn,
        resultsContainer, cardsContainer, salons, mapState, apiKey);
    });
  }

  function expandStateNames() {
    var stateNameEls = document.querySelectorAll('.salon-locator__state-name');
    stateNameEls.forEach(function (el) {
      var abbr = el.getAttribute('data-state-abbr');
      if (abbr && STATE_NAMES[abbr]) {
        el.textContent = STATE_NAMES[abbr];
      }
    });
  }

  function initStateGroups(cardsContainer) {
    if (!cardsContainer) return;
    var headers = cardsContainer.querySelectorAll('.salon-locator__state-header');
    headers.forEach(function (header) {
      header.addEventListener('click', function () {
        var cards = header.nextElementSibling;
        var isExpanded = header.getAttribute('aria-expanded') === 'true';
        header.setAttribute('aria-expanded', !isExpanded);
        cards.classList.toggle('hidden');
      });
    });
  }

  function handleMapFailure(mapWrapper, skeletonEl) {
    if (mapWrapper) mapWrapper.classList.add('hidden');
    if (skeletonEl) skeletonEl.classList.add('hidden');
  }

  function loadGoogleMapsApi(apiKey, callback) {
    if (window.google && window.google.maps) {
      callback(true);
      return;
    }

    var script = document.createElement('script');
    script.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(apiKey);
    script.async = true;
    script.defer = true;

    var timedOut = false;
    var timeout = setTimeout(function () {
      timedOut = true;
      callback(false);
    }, MAPS_LOAD_TIMEOUT_MS);

    script.onload = function () {
      if (!timedOut) {
        clearTimeout(timeout);
        callback(true);
      }
    };

    script.onerror = function () {
      if (!timedOut) {
        clearTimeout(timeout);
        callback(false);
      }
    };

    document.head.appendChild(script);
  }

  function renderMap(sectionId, mapEl, skeletonEl, mapWrapper, cardsContainer, salons, resetBtn) {
    var bounds = new google.maps.LatLngBounds();
    var map = new google.maps.Map(mapEl, {
      zoom: 5,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: true,
      zoomControl: true,
      styles: MAP_STYLES,
    });

    var activeInfoWindow = null;
    var markers = [];
    var markersByName = {};

    salons.forEach(function (salon) {
      var position = { lat: salon.lat, lng: salon.lng };
      bounds.extend(position);

      var marker = new google.maps.Marker({
        position: position,
        map: map,
        title: salon.name,
      });

      var infoContent = buildInfoWindowContent(salon);
      var infoWindow = new google.maps.InfoWindow({ content: infoContent });

      marker.addListener('click', function () {
        if (activeInfoWindow) activeInfoWindow.close();
        infoWindow.open(map, marker);
        activeInfoWindow = infoWindow;
      });

      var entry = { marker: marker, infoWindow: infoWindow, salon: salon };
      markers.push(entry);
      markersByName[salon.name] = entry;
    });

    map.fitBounds(bounds);

    google.maps.event.addListenerOnce(map, 'tilesloaded', function () {
      if (skeletonEl) skeletonEl.classList.add('hidden');
    });

    if (cardsContainer) {
      var cards = cardsContainer.querySelectorAll('.salon-locator__card');
      cards.forEach(function (card) {
        card.addEventListener('click', function (e) {
          if (e.target.closest('a[href^="tel:"]')) return;
          var salonName = card.getAttribute('data-salon-name');
          var entry = markersByName[salonName];
          if (!entry) return;

          if (activeInfoWindow) activeInfoWindow.close();
          map.panTo(entry.marker.getPosition());
          map.setZoom(14);
          entry.infoWindow.open(map, entry.marker);
          activeInfoWindow = entry.infoWindow;
          if (resetBtn) resetBtn.classList.remove('hidden');
          scrollToMap(mapWrapper);
        });
      });
    }

    // Reset map button
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        if (activeInfoWindow) activeInfoWindow.close();
        activeInfoWindow = null;
        map.fitBounds(bounds);
        resetBtn.classList.add('hidden');
      });
    }

    return {
      map: map,
      bounds: bounds,
      markers: markers,
      markersByName: markersByName,
      activeInfoWindow: activeInfoWindow,
      setActiveInfoWindow: function (iw) { activeInfoWindow = iw; },
      mapWrapper: mapWrapper,
      resetBtn: resetBtn
    };
  }

  function initSearch(searchForm, searchInput, searchError, clearBtn, geoBtn,
    resultsContainer, cardsContainer, salons, mapState, apiKey) {

    var hasSearched = false;

    searchForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var query = searchInput.value.trim();
      if (!query) return;

      searchError.classList.add('hidden');
      geocode(query, apiKey, function (location) {
        if (!location) {
          searchError.classList.remove('hidden');
          return;
        }
        hasSearched = true;
        showSearchResults(location, salons, resultsContainer, cardsContainer, mapState, clearBtn, geoBtn);
      });
    });

    clearBtn.addEventListener('click', function (e) {
      e.preventDefault();
      clearSearch(searchInput, searchError, resultsContainer, cardsContainer, mapState, clearBtn, geoBtn);
    });

    geoBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (!navigator.geolocation) return;
      navigator.geolocation.getCurrentPosition(function (pos) {
        var location = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        showSearchResults(location, salons, resultsContainer, cardsContainer, mapState, clearBtn, geoBtn);
      }, function () {
        geoBtn.classList.add('hidden');
      });
    });
  }

  function geocode(query, apiKey, callback) {
    var geocoder = new google.maps.Geocoder();
    geocoder.geocode({ address: query }, function (results, status) {
      if (status === 'OK' && results.length > 0) {
        var loc = results[0].geometry.location;
        callback({ lat: loc.lat(), lng: loc.lng() });
      } else {
        callback(null);
      }
    });
  }

  var SEARCH_RADIUS_MILES = 50;
  var MIN_RESULTS = 5;

  function showSearchResults(location, salons, resultsContainer, cardsContainer, mapState, clearBtn, geoBtn) {
    var sorted = salons
      .map(function (salon) {
        var dist = haversineDistance(location.lat, location.lng, salon.lat, salon.lng);
        return { salon: salon, distance: dist };
      })
      .sort(function (a, b) { return a.distance - b.distance; });

    // Filter to salons within radius, but always show at least MIN_RESULTS
    var nearby = sorted.filter(function (item) { return item.distance <= SEARCH_RADIUS_MILES; });
    var displayed = nearby.length >= MIN_RESULTS ? nearby : sorted.slice(0, MIN_RESULTS);

    resultsContainer.innerHTML = '';

    var bounds = new google.maps.LatLngBounds();
    bounds.extend({ lat: location.lat, lng: location.lng });

    displayed.forEach(function (item) {
      var card = document.createElement('div');
      card.className = 'salon-locator__card';
      card.setAttribute('data-salon-name', item.salon.name);
      card.innerHTML =
        '<p class="salon-locator__card-name">' + escapeHtml(item.salon.name) + '</p>' +
        '<p class="salon-locator__card-location">' + escapeHtml(item.salon.city) + ', ' + escapeHtml(item.salon.state) + '</p>' +
        '<p class="salon-locator__card-phone"><a href="tel:' + escapeHtml(item.salon.phone.replace(/[\s()\-]/g, '')) + '">' + escapeHtml(item.salon.phone) + '</a></p>' +
        '<p class="salon-locator__card-distance">' + item.distance.toFixed(1) + ' mi</p>';

      card.addEventListener('click', function (e) {
        if (e.target.closest('a[href^="tel:"]')) return;
        var entry = mapState.markersByName[item.salon.name];
        if (!entry) return;

        if (mapState.activeInfoWindow) mapState.activeInfoWindow.close();
        mapState.map.panTo(entry.marker.getPosition());
        mapState.map.setZoom(14);
        entry.infoWindow.open(mapState.map, entry.marker);
        mapState.setActiveInfoWindow(entry.infoWindow);
        if (mapState.resetBtn) mapState.resetBtn.classList.remove('hidden');
        scrollToMap(mapState.mapWrapper);
      });

      resultsContainer.appendChild(card);
      bounds.extend({ lat: item.salon.lat, lng: item.salon.lng });
    });

    cardsContainer.classList.add('salon-locator__cards--searching');
    resultsContainer.classList.remove('hidden');
    clearBtn.classList.remove('hidden');
    geoBtn.classList.remove('hidden');

    mapState.map.fitBounds(bounds);
  }

  function clearSearch(searchInput, searchError, resultsContainer, cardsContainer, mapState, clearBtn, geoBtn) {
    searchInput.value = '';
    searchError.classList.add('hidden');
    resultsContainer.innerHTML = '';
    resultsContainer.classList.add('hidden');
    cardsContainer.classList.remove('salon-locator__cards--searching');
    clearBtn.classList.add('hidden');
    geoBtn.classList.add('hidden');
    mapState.map.fitBounds(mapState.bounds);
  }

  function haversineDistance(lat1, lng1, lat2, lng2) {
    var R = 3958.8;
    var dLat = toRad(lat2 - lat1);
    var dLng = toRad(lng2 - lng1);
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
      Math.sin(dLng / 2) * Math.sin(dLng / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  function toRad(deg) {
    return deg * (Math.PI / 180);
  }

  function buildInfoWindowContent(salon) {
    var html = '<div class="salon-locator__info">';
    html += '<p class="salon-locator__info-name">' + escapeHtml(salon.name) + '</p>';
    html += '<p class="salon-locator__info-address">' + escapeHtml(salon.address) + '</p>';
    html += '<p class="salon-locator__info-phone"><a href="tel:' + escapeHtml(salon.phone.replace(/[\s()\-]/g, '')) + '">' + escapeHtml(salon.phone) + '</a></p>';
    if (salon.email) {
      html += '<p class="salon-locator__info-email"><a href="mailto:' + escapeHtml(salon.email) + '">' + escapeHtml(salon.email) + '</a></p>';
    }
    html += '</div>';
    return html;
  }

  function scrollToMap(mapWrapper) {
    if (!mapWrapper) return;
    var rect = mapWrapper.getBoundingClientRect();
    var isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
    if (!isVisible) {
      mapWrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  document.addEventListener('DOMContentLoaded', function () {
    var configs = window.salonLocatorConfig || {};
    Object.keys(configs).forEach(function (sectionId) {
      var config = configs[sectionId];
      initSalonLocator(config.sectionId, config.apiKey);
    });
  });
})();
